import _slicedToArray from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useRef, useState } from "react";
import { StyledSkeletonContainer } from "./styles";

var SkeletonLoader = function SkeletonLoader(e) {
  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      o = _useState2[1],
      r = useRef(null);

  return useEffect(function () {
    var e;
    o((null === (e = r.current) || void 0 === e ? void 0 : e.clientWidth) || 0);
  }), React.createElement(StyledSkeletonContainer, Object.assign({
    ref: r,
    "data-testid": e.testId ? e.testId : "skeleton-loader",
    realWidth: t
  }, e));
};

export { SkeletonLoader };